module.exports = __webpack_public_path__ + "img/metrics.fdcb1a1d.png";